"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.areFieldsValid = void 0;
require("react-final-form-hooks");
require("../../../core");
const areFieldsValid = (fields, formApi) => {
    const state = formApi.form.getFieldState;
    return fields.reduce((isValid, fieldName) => {
        var _a;
        const field = state(fieldName);
        return isValid && ((_a = field === null || field === void 0 ? void 0 : field.valid) !== null && _a !== void 0 ? _a : false);
    }, true);
};
exports.areFieldsValid = areFieldsValid;
//# sourceMappingURL=areFieldsValid.js.map